import { createFileRoute, } from '@tanstack/react-router';
import { DesignSystem, } from '../../../pages/dev/DesignSystem.js';
export const Route = createFileRoute('/dev/designsystem')({
    component: DesignSystem,
});
//# sourceMappingURL=designsystem.js.map